import React, { useState } from "react";

export function NfcReader() {
  const [status, setStatus] = useState("Ready");
  const [records, setRecords] = useState<string[]>([]);

  const handleScan = async () => {
    if (!("NDEFReader" in window)) {
      setStatus("❌ Web NFC not supported on this device/browser.");
      return;
    }

    try {
      const ndef = new (window as any).NDEFReader();
      await ndef.scan();
      setStatus("✅ Scan started. Tap an NFC tag...");

      ndef.onreading = (event: any) => {
        const decoder = new TextDecoder();
        const newRecords: string[] = [];
        for (const record of event.message.records) {
          let text = "";
          if (record.recordType === "text") {
            text = decoder.decode(record.data);
          } else if (record.recordType === "url") {
            text = `URL: ${decoder.decode(record.data)}`;
          } else {
            text = `[${record.recordType}] ${decoder.decode(record.data)}`;
          }
          newRecords.push(text);
        }
        setRecords(newRecords);
      };
    } catch (err: any) {
      setStatus(`⚠️ Error: ${err.message}`);
    }
  };

  return (
    <div className="mt-8 flex flex-col items-center">
      <button
        onClick={handleScan}
        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg shadow-md transition"
      >
        Scan NFC Tag
      </button>

      <p className="mt-4 text-gray-300">{status}</p>

      {records.length > 0 && (
        <div className="mt-4 bg-gray-900 p-4 rounded-lg text-left w-full max-w-md">
          <h3 className="text-lg font-bold mb-2 text-white">NFC Data:</h3>
          {records.map((r, i) => (
            <p key={i} className="text-sm text-gray-200 break-words">
              {r}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
